var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C132.521,0,32.062,100.458,32.062,223.938v184.707L256,512l223.938-103.356V223.938 C479.938,100.458,379.479,0,256,0z M256,46.332c31.915,0,61.887,8.466,87.799,23.265c-37.467,16.448-68.244,44.889-87.799,80.188 c-19.557-35.297-50.332-63.739-87.799-80.188C194.113,54.798,224.085,46.332,256,46.332z M433.606,378.998L256,460.97 L78.394,378.998V223.938c0-46.218,17.751-88.363,46.786-119.992c52.134,12,92.438,53.197,104.163,104.548h53.313 c11.727-51.351,52.029-92.548,104.163-104.546c29.035,31.628,46.786,73.774,46.786,119.99V378.998z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 155.614,
    cy: 231.66,
    r: 23.166
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 356.386,
    cy: 231.66,
    r: 23.166
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.465,290.347C273.929,279.242,256,270.269,256,270.269s-17.927,8.973-26.465,20.077 c-2.734,2.785-4.423,6.599-4.423,10.811c0,4.212,1.691,8.026,4.423,10.811C238.071,323.072,256,332.045,256,332.045 s17.927-8.973,26.465-20.077c2.734-2.784,4.423-6.599,4.423-10.811C286.888,296.946,285.197,293.131,282.465,290.347z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdSurvey);
export default __webpack_public_path__ + "static/media/bird-survey.e8537629a80f80d7543b484a33003f74.svg";
export { ForwardRef as ReactComponent };